import GallerySliderVideo from '@components/components/Slider/GallerySlider/GallerySliderVideo';
import { Container } from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';

const CmsGalleryExtendedVideo = ({ size, ...props }) => (
  <Container size={size}>
    <GallerySliderVideo {...props} />
  </Container>
);

CmsGalleryExtendedVideo.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'full']),
};

CmsGalleryExtendedVideo.defaultProps = {
  size: 'xl',
};

export default CmsGalleryExtendedVideo;
